import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
	Form,
	Row,
	Col,
	Card,
	notification,
	Tag,
	Skeleton,
	Spin,
	Divider,
	Button,
} from "antd";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import { FormOutlined } from "@ant-design/icons";
import approvalService from "../../services/approver";

import CommentSystem from "../../components/comment";
import CreatedByComponent from "../../components/commonDetails/createdBy";
import ApproversComponent from "../../components/commonDetails/approvers";
import ApproveDisapproveComponent from "../../components/commonDetails/approveDisapprove/index";
import TaskStatus from "../../components/commonDetails/taskStatus";
import mobileRequisitionService from "../../services/mobileRequisition";
import FeedbackModal from "../../components/feedbackModal";
import DeploymentModal from "../../components/deploymentModal";

import AddApproversComponent from "../../components/commonDetails/manageApprovers";
import { useSelector } from "react-redux";

import TaskModal from "../../components/taskModal";
import { replaceLineBreaks } from "../../utils/helper";

const MobileRequisitionDetails = () => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(null);
	const [data, setData] = useState(null);
	const [assignedUserId, setAssignedUserId] = useState(null);
	const { id } = useParams();
	const [formId] = useState(5);
	const { currentUser } = useSelector((state) => state.user);

	// PRINT STYLES & PRINT HANDLER
	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #qqq{
          display:none;
        }
        #ppp, #ppp * {
          visibility: visible;
        }
        #ppp {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    `;
		document.head.appendChild(style);
		return () => {
			document.head.removeChild(style);
		};
	}, []);

	const [isPrintable, setIsPrintable] = useState(false);
	const handlePrintClick = () => {
		setIsPrintable(true);
		setTimeout(() => {
			window.print();
			setIsPrintable(false);
		}, 100);
	};
	useEffect(() => {
		getMRDetails();
	}, []);

	const getMRDetails = async () => {
		setLoading(true);
		await mobileRequisitionService.getMRDetails(id).then((response) => {
			setData(response);
			setLoading(false);
		});
	};

	const handleSubmit = async (values, isParallel) => {
		setLoading(true);
		const formattedValues = {
			status,
			approved_disapproved: false,
			form_id: 5,
			key: parseInt(id),
			reason: values.message,
			...(isParallel && { assigned_user_id: assignedUserId }),
		};

		const serviceMethod = isParallel
			? approvalService.updateParallelStatus
			: approvalService.updateStatus;

		try {
			const response = await serviceMethod(formattedValues);
			if (response.success) {
				notification.success({
					message: "Status",
					description: response.message,
				});
				form.resetFields();
				getMRDetails(id);
			}
		} catch (error) {
			notification.error({
				message: "Error",
				description: error.response?.data?.message || "An error occurred",
			});
		} finally {
			setLoading(false);
		}
	};

	// Comment Condition Updated
	let canComment = 0;
	if (data) {
		if (data.status != "Approved" && data.status != "Return") {
			canComment = 1;
		} else {
			if (data.comment_status == 1) {
				canComment = 1;
			}
		}
	}
	// Comment Condition Updated

	const Isadmin = currentUser.roles.includes("admin");

	//  For hiding next hierarchy to the user
	let filteredApprovers = [];
	if (data) {
		const allApprovers = data.approvers;

		if (Array.isArray(allApprovers)) {
			filteredApprovers = allApprovers.map((approver) => ({
				...approver,
				users: approver.users
					? approver.users.filter((user) => user.status === "Processing")
					: [],
			}));

			console.log("filteredApprovers");
			console.log(filteredApprovers);
		} else {
			console.error("allApprovers is not defined or is not an array.");
		}
	}
	//  For hiding next hierarchy to the user

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header icon={<FormOutlined />} title='Mobile Requisition Details' />
				</Col>
			</Row>
			{/* PRINTABLE CARD */}
			{isPrintable && (
				<Card
					style={{
						minHeight: "100vh",
						marginLeft: "0",
						marginTop: "0",
						border: "none",
						padding: 24,
						background: "#fff",
					}}
					id='ppp'
				>
					<Row gutter={[24, 24]}>
						<Col span={24} style={{ textAlign: "center" }}>
							<img
								src={
									currentUser?.company?.logo
										? currentUser.company.logo.replace("/uploads", "")
										: "https://www.lucky-cement.com/wp-content/uploads/2017/02/lucky-logo.png"
								}
								alt='Logo'
								style={{ height: "40px", width: "auto", marginBottom: 16 }}
							/>
							<h2 style={{ marginBottom: 0 }}>
								<strong>Mobile Requisition Form</strong>
							</h2>
							<div style={{ fontSize: 12, marginBottom: 16 }}>
								<b>Sequence No:</b> {data.sequence_no} &nbsp; | &nbsp;
								<b>Request Title:</b> {data.request_title} &nbsp; | &nbsp;
								<b>Status:</b> {data.status}
							</div>
						</Col>
					</Row>
					<Divider />
					<Row gutter={[16, 16]}>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>Issue Date:</b>{" "}
							<Tag>{new Date(data.issue_date).toLocaleDateString()}</Tag>
						</Col>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>Recieve Date:</b>{" "}
							<Tag>{new Date(data.recieve_date).toLocaleDateString()}</Tag>
						</Col>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>Make:</b> <Tag>{data.make?.name}</Tag>
						</Col>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>Model:</b> <Tag>{data.model}</Tag>
						</Col>
					</Row>
					<Row gutter={[16, 16]}>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>IMEI:</b> <Tag>{data.imei}</Tag>
						</Col>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>Mobile Number:</b> <Tag>{data.mobile_number}</Tag>
						</Col>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>Remarks:</b> <Tag>{data.remarks}</Tag>
						</Col>
						<Col xs={24} sm={12} md={8} lg={6} xl={6}>
							<b>Request For User:</b> <Tag>{data.request_for_user?.name}</Tag>
						</Col>
					</Row>
					<Divider />
					<Card
						title={<span style={{ fontSize: "14px" }}>Created By</span>}
						className=''
						// style={{ border: "none"}}
						style={{
							border: "none",
							pageBreakBefore: "always",
							margin: "-10px",
						}}
					>
						{data && data.created_by && (
							<>
								<Row gutter={[8, 8]} className=''>
									<Col xs={24} sm={8} md={8} lg={8} xl={8}>
										<span className='fs-10 '>
											<strong>Created At</strong>&nbsp;
										</span>
										<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
											&nbsp;{data.created_at}{" "}
										</Tag>
									</Col>

									<Col xs={24} sm={8} md={8} lg={8} xl={8}>
										<span className='fs-10 '>
											<strong>Name</strong>&nbsp;
										</span>
										<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
											&nbsp;{data.created_by.name}{" "}
										</Tag>
									</Col>

									<Col xs={24} sm={8} md={8} lg={8} xl={8}>
										<span className='fs-10 '>
											<strong>Department:</strong>&nbsp;
										</span>
										<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
											&nbsp;{data.department.name}{" "}
										</Tag>
									</Col>
								</Row>
							</>
						)}
					</Card>
					<Card
						title={
							<span
								style={{
									fontSize: "14px",
									display: "block",
									textAlign: "center",
								}}
							>
								Approvers
							</span>
						}
						className=''
						style={{
							border: "none",
						}}
					>
						<Row gutter={[16, 16]}>
							<Col span={24}>
								<div style={{ overflowX: "auto", marginTop: 8 }}>
									<table
										style={{
											width: "100%",
											borderCollapse: "collapse",
											fontSize: 13,
										}}
									>
										<thead>
											<tr style={{ background: "#f5f5f5" }}>
												<th style={{ padding: 8, border: "1px solid #eee" }}>
													Group
												</th>
												<th style={{ padding: 8, border: "1px solid #eee" }}>
													Name
												</th>
												<th style={{ padding: 8, border: "1px solid #eee" }}>
													Status
												</th>
												<th style={{ padding: 8, border: "1px solid #eee" }}>
													Action Performed At
												</th>
											</tr>
										</thead>
										<tbody>
											{data?.approvers && data.approvers.length > 0 ? (
												data.approvers.flatMap((group) => {
													const users = Array.isArray(group.users)
														? group.users
														: [];

													return users.length > 0 ? (
														users.map((approver, uidx) => (
															<tr key={`${group.id}-${approver.id || uidx}`}>
																{/* Show group name only on first user */}
																{uidx === 0 && (
																	<td
																		rowSpan={users.length}
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																			fontWeight: "bold",
																			background: "#fafafa",
																			verticalAlign: "top",
																		}}
																	>
																		{group.name || "-"}
																	</td>
																)}
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.name || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status || "Pending"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status_at || "-"}
																</td>
															</tr>
														))
													) : (
														<tr key={group.id}>
															<td>{group.name || "-"}</td>
															<td colSpan={3} style={{ textAlign: "center" }}>
																No users found.
															</td>
														</tr>
													);
												})
											) : (
												<tr>
													<td
														colSpan={4}
														style={{ padding: 8, textAlign: "center" }}
													>
														No approvers found.
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</Col>
						</Row>
					</Card>
					<Divider />
					{data &&
						data.quality_assurances &&
						data.quality_assurances.length > 0 && (
							<>
								<Divider />
								<Card
									title={
										<span
											style={{
												fontSize: "14px",
												display: "block",
												textAlign: "center",
											}}
										>
											Quality Assurance Details
										</span>
									}
									className=''
									style={{
										border: "none",
									}}
								>
									<Row gutter={[16, 16]}>
										<Col span={24}>
											<div style={{ overflowX: "auto", marginTop: 8 }}>
												<table
													style={{
														width: "100%",
														borderCollapse: "collapse",
														fontSize: 13,
													}}
												>
													<thead>
														<tr style={{ background: "#f5f5f5" }}>
															<th
																style={{
																	padding: 8,
																	border: "1px solid #eee",
																}}
															>
																QA User
															</th>
															<th
																style={{
																	padding: 8,
																	border: "1px solid #eee",
																}}
															>
																Status
															</th>
															<th
																style={{
																	padding: 8,
																	border: "1px solid #eee",
																}}
															>
																Testing Type
															</th>
															<th
																style={{
																	padding: 8,
																	border: "1px solid #eee",
																}}
															>
																Status At
															</th>
															<th
																style={{
																	padding: 8,
																	border: "1px solid #eee",
																}}
															>
																Feedback
															</th>
														</tr>
													</thead>
													<tbody>
														{data.quality_assurances.map((qa) => (
															<tr key={qa.id}>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{qa.qa_user?.name || "Unassigned"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{qa.status ? (
																		<Tag
																			color={
																				qa.status === "Modification Required"
																					? "orange"
																					: "green"
																			}
																		>
																			{qa.status}
																		</Tag>
																	) : (
																		<Tag>Pending</Tag>
																	)}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{qa.testing_type || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{qa.status_at || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{qa.feedback ? (
																		<div
																			dangerouslySetInnerHTML={{
																				__html: replaceLineBreaks(qa.feedback),
																			}}
																		/>
																	) : (
																		"-"
																	)}
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</Col>
									</Row>
								</Card>
							</>
						)}

					<Divider />
					<Row gutter={[16, 16]}>
						<Col span={24} style={{ fontSize: 12, marginTop: 16 }}>
							This document has been approved through the system-based workflow.
							<br />
							Detailed information for Mobile Requisition ID: {id} can be
							accessed from this link.{" "}
							<a
								href={window.location.href}
								target='_blank'
								rel='noopener noreferrer'
							>
								View Details
							</a>
						</Col>
					</Row>
				</Card>
			)}

			{/* WEB PAGE CARD */}
			<Card style={{ minHeight: "100vh" }} id='qqq'>
				{/*<Card style={{ minHeight: "100vh" }} className="print-area">*/}
				<Row gutter={[24, 24]}>
					<Col lg={5} md={5} sm={7} xs={7}>
						<CreatedByComponent data={data} />
						<Button
							type='primary'
							onClick={handlePrintClick}
							style={{
								marginTop: "20px",
								marginBottom: "20px",
								width: "100%",
							}}
						>
							Print Document
						</Button>

						{data &&
							(data.status === "Pending" || data.status === "Approved") &&
							Isadmin === true && (
								<AddApproversComponent data={data && data} formId={formId} />
							)}
						{/*<ApproversComponent approvers={data && filteredApprovers} />*/}
						<ApproversComponent approvers={data && data.approvers} />
					</Col>
					<Col lg={19} md={19} sm={17} xs={17}>
						<div>
							{data?.deployments !== null && (
								<DeploymentModal
									title='Deployments'
									data_deployment={data?.deployments}
									style={{ marginright: "0" }}
								/>
							)}
							{data?.assigned_task?.assign_task_teams[0]?.members?.some(
								(m) => m.start_at && m.due_at
							) && (
								<TaskModal
									title='Tasks Logs'
									data_tasks={data.assigned_task.assign_task_teams[0].members}
									style={{ marginright: "0" }}
								/>
							)}
							{data?.approved_disapproved === true && (
								<div
									style={{
										position: "sticky",
										top: 1,
										zIndex: 999,
										background: "#fff",
										padding: "5px",
										borderRadius: "4px",
									}}
								>
									<Spin spinning={loading}>
										{data?.task_status?.id !== null && (
											<FeedbackModal
												title='QA Feedback'
												formId={formId}
												assurable_id={id}
												style={{ marginright: "0" }}
											/>
										)}
										<b>Approval Request</b>
										<ApproveDisapproveComponent
											form={form}
											handleStatus={(values) => handleSubmit(values, false)}
											loading={loading}
											setStatus={setStatus}
										/>
									</Spin>
								</div>
							)}

							{data?.parallel_approved_disapproved === true && (
								<div
									style={{
										position: "sticky",
										top: data?.approved_disapproved ? "150px" : "1px", // Adjust the top value as needed
										zIndex: 999,
										background: "#fff", // Add a background color
										padding: "5px", // Add padding for better visual separation
										borderRadius: "4px", // Optional: Add rounded corners
									}}
								>
									<Spin spinning={loading}>
										<b>Parallel Approval Request</b>
										<ApproveDisapproveComponent
											form={form}
											handleStatus={(values) => handleSubmit(values, true)}
											loading={loading}
											setStatus={setStatus}
											parallel={true}
											parallelUsers={
												data && data.parallel_approved_disapproved_users
											}
											setAssignedUserId={setAssignedUserId}
											reloadData={getMRDetails}
										/>
									</Spin>
								</div>
							)}

							{data?.assigned_task_to_me === true && (
								<div
									style={{
										position: "sticky",
										top: "1px",
										zIndex: 999,
										background: "#fff", // Add a background color
										padding: "5px", // Add padding for better visual separation
										borderRadius: "4px", // Optional: Add rounded corners
									}}
								>
									<TaskStatus
										data={data}
										reloadData={getMRDetails}
										formId={formId}
									/>
								</div>
							)}

							<Skeleton active loading={loading}>
								{data && (
									<>
										<Card title='Basic Information' className='mb-10'>
											<Row gutter={[16, 16]}>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Sequence No</p>
													<Tag>{data.sequence_no}</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Request Title</p>
													<Tag>{data.request_title}</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Status</p>
													<Tag>{data.status}</Tag>
												</Col>

												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Issue Date</p>
													<Tag>
														{new Date(data.issue_date).toLocaleDateString()}
													</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Receive Date</p>
													<Tag>
														{new Date(data.recieve_date).toLocaleDateString()}
													</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Make</p>
													<Tag>{data.make?.name}</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Model</p>
													<Tag>{data.model}</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>IMEI</p>
													<Tag>{data.imei}</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Mobile Number</p>
													<Tag>{data.mobile_number}</Tag>
												</Col>
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Remarks</p>
													<Tag>{data.remarks}</Tag>
												</Col>

												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10'>Request For User</p>
													<Tag>{data.request_for_user?.name}</Tag>
												</Col>
												{data && data.assigned_task?.start_at && (
													<Col xs={24} sm={12} md={8} lg={6} xl={6}>
														<p className='fs-12 mb-10 '>Start Date</p>
														<Tag>{data.assigned_task?.start_at}</Tag>
													</Col>
												)}
												{data && data.assigned_task?.due_at && (
													<Col xs={24} sm={12} md={8} lg={6} xl={6}>
														<p className='fs-12 mb-10 '>Deadline</p>
														<Tag>{data.assigned_task?.due_at}</Tag>
													</Col>
												)}
											</Row>
										</Card>

										{/* <Card title="Approvers" className="mb-10">
        <Row gutter={[16, 16]}>
          {data.approvers.map((approver) => (
            <Col xs={24} sm={24} md={24} lg={24} xl={24} key={approver.id}>
              <p className="fs-12 mb-10">{approver.name}</p>
              {approver.users.map((user) => (
                <Tag key={user.id}>{user.name}</Tag>
              ))}
            </Col>
          ))}
        </Row>
      </Card> */}
									</>
								)}
							</Skeleton>

							{/* FOR CUSTOM FIELDS */}
							{Array.isArray(data?.custom_fields) && data.custom_fields.length > 0 && (
								<Card title="System Generated Fields" className="mb-10">
									<Row gutter={[16, 16]}>
									{data.custom_fields.map((field) => {
										const type = field.custom_field?.type || "Input";
										const colSpan = type === "Textarea" ? 12 : 6;

										return (
										<Col
											key={field.id}
											xs={24}
											sm={12}
											md={colSpan}
											lg={colSpan}
											xl={colSpan}
											className="mb-20"
										>
											<p className="fs-12 mb-10 bold">
											{field.custom_field?.label || "Field"}
											</p>

											{field.value ? (
											type === "Multi" ? (
												field.value.split(",").map((val) => (
												<Tag key={val.trim()} color="blue" className="mb-5">
													{val.trim()}
												</Tag>
												))
											) : (
												<div
												style={{ wordBreak: "break-word" }}
												dangerouslySetInnerHTML={{
													__html: replaceLineBreaks(field.value),
												}}
												/>
											)
											) : (
											"-"
											)}
										</Col>
										);
									})}
									</Row>
								</Card>
							)}
						</div>

						<Skeleton active loading={loading}>
							<Card title='Comments' className='mb-10'>
								<Row gutter={16}>
									<Col span={24}>
										<CommentSystem
											id={id}
											form_id={5}
											status={data && data.status}
											comment_status={data && canComment}
										/>
									</Col>
								</Row>
							</Card>
						</Skeleton>
					</Col>
				</Row>
			</Card>
		</DefaultLayout>
	);
};

export default MobileRequisitionDetails;
